import React, { useState } from "react";

function TruncateUserName({ textContent }) {
  const [showFullText, setShowFullText] = useState(false);

  const extractTextContent = (children) => {
    if (children === null || children === undefined) return "";
    if (typeof children === "string" || typeof children === "number") {
      return String(children);
    }
    // Convert JSX children to an array of React elements
    const elements = React.Children.toArray(children);
    // Concatenate text content from each element
    return elements.reduce((acc, child) => {
      if (typeof child === "string" || typeof child === "number") {
        return acc + child;
      } else if (typeof child === "object" && child?.props?.children) {
        return acc + extractTextContent(child.props.children);
      }
      return acc;
    }, "");
  };

  // Extract text content from the provided JSX and trim whitespace
  const rawText = typeof textContent === "string" ? textContent : extractTextContent(textContent);
  const extractedTextContent = (rawText || "").replace(/\s+/g, " ").trim();

  const handleMouseOver = () => {
    if (extractedTextContent.length > 16) {
      setShowFullText(true);
    }
  };

  const handleMouseOut = () => {
    setShowFullText(false);
  };

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    const cleanText = text.replace(/\s+/g, " ").trim();
    if (cleanText.length > maxLength) {
      return cleanText.substr(0, maxLength).trim() + "...";
    }
    return cleanText;
  };

  const fieldClass = showFullText ? "value-field full-text" : "value-field";

  return (
    <div className="tran-outer">
      <div
        className={fieldClass}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        {showFullText ? textContent : truncateText(extractedTextContent, 16)}
      </div>
    </div>
  );
}

export default TruncateUserName;
